<template>
    <div class="form-group row m-b-sm">
                        
        <div class="col-md-5">
            <input type="text" 
                class="form-control" 
                v-model="rowData.from"
                @change="fromChange"
                :readonly="rowData.fromReadonly"
                name="aging[from][]">
        </div>
        
        <div class="col-md-5">
            <input type="text" 
                class="form-control" 
                v-model="rowData.to"
                @change="toChange"
                name="aging[to][]">
        </div>
        
        <div class="col-md-2 table-icons">
            <a href="#"
                class="icon-delete" 
                data-toggle="tooltip"
                data-placement="top" 
                title="" 
                :data-original-title="__('delete')"
                @click.prevent="deleteRow">
                <i class="fa fa-trash m-t-xs"></i>
            </a>
        </div>	               
    </div>
</template>

<script>
    export default {
        name: 'form-inputs-row',
        data: function() {
            return {
                
            }
        },
        props: {
            id: Number,
            value: Object
        },
        computed: {
            rowData: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },
        methods: {
            deleteRow() {
                this.$emit('delete', this.id)
                $(function () {
                    $('.tooltip').remove()
                })
            },
            toChange() {
                if(parseInt(this.rowData.to) <= parseInt(this.rowData.from)) {
                    this.rowData.to = this.rowData.from*1 + 1
                }

                this.$emit('change', this.id, this.rowData);
            },
            fromChange() {
                if(parseInt(this.rowData.from) >= parseInt(this.rowData.to)) {
                    this.rowData.from = this.rowData.to*1 - 1
                }
                
                this.$emit('change', this.id, this.rowData);
            }
        },
        
        mounted () {
             $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            })
        },
        
    }
</script>
